import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { APP_ROUTES } from './appRoutes';
import { Box, Typography, Button } from '@mui/material';

// Usage: <Route element={<Restricted moduleKey="messages" />}>
//           <Route path={APP_ROUTES.MESSAGES} element={<WhatsAppLayout/>} />
//        </Route>

export default function Restricted({ moduleKey }) {
  const { user } = useSelector((state) => state.authentication || {});
  const moduleAccess = user?.module_access || {};

  if (!moduleKey) return <Outlet />; // no restriction

  const val = moduleAccess[moduleKey];
  const allowed = val === true || val === 'true' || val === 1 || val === '1';

  if (allowed) return <Outlet />;

  // Simple access-denied UI using MUI
  const AccessDenied = () => {
    const navigate = useNavigate();
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h5" sx={{ mb: 1 }}>You don't have access</Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>Please contact your administrator to request access to this module.</Typography>
        <Button variant="contained" color="primary" onClick={() => navigate(APP_ROUTES.DASHBOARD)}>
          Back to Dashboard
        </Button>
      </Box>
    );
  };

  return <AccessDenied />;
}
